import { useContext, useState } from "react";
import { AppContext } from "../App";
import { MdMenu, MdKeyboardArrowDown, MdLogin } from "react-icons/md";
import YCSC_logo from "../assets/logo.png";
import file1 from "../assets/downloads/sample1.pdf";

export default function TopBar() {
  const appContext = useContext(AppContext);
  const [activeDropdown, setActiveDropdown] = useState(null);

  function goTo(item, subItem) {
    appContext.navTo({ item, subItem });
    setActiveDropdown(null);
  }

  const isTabActive = (item) =>
    appContext.navItem === item || (!appContext.navItem && item === "home");

  return (
    <div className="TopBar saccos-topbar-root">
      <div className="saccos-nav-body h-100">
        <div className="container d-flex justify-content-between align-items-center h-100 saccos-nav-container">
          {/* ================= BRAND LOGO AREA (LEFT) ================= */}
          <div className="d-flex align-items-center h-100 flex-shrink-0">
            <MdMenu
              className="align-self-center mMobileOnly text-primary me-3 saccos-hamburger-menu"
              size={32}
              onClick={appContext.openSideBar}
            />

            {/* Desktop Logo */}
            <img
              src={YCSC_logo}
              alt="YCSC SACCOS Logo"
              className="align-self-center mDesktopOnly brand-logo-transition saccos-desktop-logo"
              onClick={() => goTo("home")}
            />

            {/* Mobile Logo */}
            <img
              src={YCSC_logo}
              alt="YCSC SACCOS Logo"
              className="align-self-center mMobileOnly saccos-mobile-logo"
              onClick={() => goTo("home")}
            />

            <h5 onClick={() => goTo("home")} className="topbar-brand-title fw-bold mb-0 ms-2">
              YCSC <span className="text-secondary-accent">SACCOS</span>
            </h5>
          </div>

          {/* ================= CENTERED DESKTOP MENU LINKS ================= */}
          <div className="DesktopMenu align-self-center mNoMargin mNoPadding mDesktopOnly h-100 mx-auto d-flex justify-content-center align-items-center saccos-menu-row">
            {/* Home Link */}
            <div
              className={`saccos-nav-item text-uppercase ${isTabActive("home") ? "saccos-item-active" : ""}`}
              onClick={() => goTo("home")}
            >
              Mwanzo
            </div>

            {/* About Dropdown */}
            <div
              className={`saccos-nav-item text-uppercase position-relative saccos-dropdown-wrapper ${
                ["about_us", "leadership"].includes(appContext.navItem)
                  ? "saccos-item-active"
                  : ""
              }`}
              onMouseEnter={() => setActiveDropdown("about")}
              onMouseLeave={() => setActiveDropdown(null)}
            >
              <span className="d-flex align-items-center gap-1">
                Kuhusu Sisi{" "}
                <MdKeyboardArrowDown className="saccos-arrow-icon" size={16} />
              </span>
              <div
                className={`saccos-custom-dropdown ${activeDropdown === "about" ? "saccos-show-menu" : ""}`}
              >
                <div
                  className="saccos-dropdown-link"
                  onClick={() => goTo("about_us")}
                >
                  Muhtasari & Maadili
                </div>
                <div
                  className="saccos-dropdown-link"
                  onClick={() => goTo("leadership")}
                >
                  Uongozi & Utawala
                </div>
              </div>
            </div>

            {/* Services Dropdown */}
            <div
              className={`saccos-nav-item text-uppercase position-relative saccos-dropdown-wrapper ${
                ["loans", "savings_deposits"].includes(appContext.navItem)
                  ? "saccos-item-active"
                  : ""
              }`}
              onMouseEnter={() => setActiveDropdown("services")}
              onMouseLeave={() => setActiveDropdown(null)}
            >
              <span onClick={() => goTo("services")} className="d-flex align-items-center gap-1">
                Huduma Zetu{" "}
                <MdKeyboardArrowDown className="saccos-arrow-icon" size={16} />
              </span>
              <div
                className={`saccos-custom-dropdown ${activeDropdown === "services" ? "saccos-show-menu" : ""}`}
              >
                <div
                  className="saccos-dropdown-link"
                  onClick={() => goTo("services","loans")}
                >
                  Mikopo Yetu
                </div>
                <div
                  className="saccos-dropdown-link"
                  onClick={() => goTo("services","savings_deposits")}
                >
                  Hisa, Akiba & Amana
                </div>
              </div>
            </div>

            {/* News Link */}
            <div
              className={`saccos-nav-item text-uppercase ${isTabActive("news") ? "saccos-item-active" : ""}`}
              onClick={() => goTo("news")}
            >
              Habari
            </div>

            {/* Gallery Link */}
            <div
              className={`saccos-nav-item text-uppercase ${isTabActive("gallery") ? "saccos-item-active" : ""}`}
              onClick={() => goTo("gallery")}
            >
              Matunzio
            </div>

            {/* FAQs Link */}
            <div
              className={`saccos-nav-item text-uppercase ${isTabActive("faqs") ? "saccos-item-active" : ""}`}
              onClick={() => goTo("faqs")}
            >
              FAQs
            </div>

            {/* Contact Link */}
            <div
              className={`saccos-nav-item text-uppercase ${isTabActive("contact_us") ? "saccos-item-active" : ""}`}
              onClick={() => goTo("contact_us")}
            >
              Mawasiliano
            </div>
          </div>

          {/* ================= ACTIONS PORTAL (RIGHT AREA) ================= */}
          <div className="mDesktopOnly d-flex align-items-center flex-shrink-0 h-100 saccos-action-block">
            <a
              href={file1}
              download={"Fomu ya Kujiunga YCSC"}
              target="_blank"
              rel="noreferrer"
              className="text-decoration-none"
            >
              <button className="btn saccos-portal-btn d-flex align-items-center gap-2">
                <MdLogin size={16} />
                <span>JIUNGE NASI</span>
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
